import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { BaseHeader } from '../header-elements/base-header';
import { HeaderRegion } from '../header-elements/header-region';
import { HeaderImageToolbar } from '../../header-image-toolbar';
import { CobrandHeaderImageToolbar } from '../../cobrand_header-image-toolbar';
export var HeaderMinimalTemplateB = function (props) {
    var headerData = props.headerData;
    var headerImg = headerData.headerImg;
    return (React.createElement(HeaderRegion, null,
        React.createElement(EGDSSpacing, { padding: { inlinestart: 'six', inlineend: 'two' } },
            React.createElement(BaseHeader, { className: "global_navigation__header__default__max_width" },
                React.createElement("div", null,
                    React.createElement(Experiment, { name: "Hawaiian_APAC_CoBranding" },
                        React.createElement(ExperimentControl, null,
                            React.createElement(HeaderImageToolbar, { headerImg: headerImg })),
                        React.createElement(ExperimentVariant, { bucket: 1 },
                            React.createElement(CobrandHeaderImageToolbar, { headerImg: headerImg }))))))));
};
//# sourceMappingURL=header-minimal-template-b.js.map